export enum EnumDistributorRevisionSession {
  EDIT_REQUEST_ADMIN = 'revisionNoteEditRequestAdmin',
  REGISTRATION_ADMIN = 'revisionNoteRegistration',
  REGISTRATION_FINANCE = 'revisionNoteRegistrationFinance',
  EDIT_REQUEST_FINANCE = 'revisionNoteEditRequestFinance',
  VERIFY_KUL = 'revisionNoteVerificationKul',
}
